import { Enumify } from 'enumify';

class RecordingType extends Enumify {
    static Audio = new RecordingType('Audio');
    static Video = new RecordingType('Video');
    static _ = this.closeEnum();
}

export default RecordingType;
